document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth > 768) return;
  document.querySelectorAll('[data-section-type="slideshow"] .slider-component').forEach(function(el) {
    // flickity instance е записан като el.flickity на slider-component
    var flkty = el.flickity;
    if (!flkty) return;
    flkty.options.cellAlign   = 'center';
    flkty.options.contain     = true;
    flkty.options.wrapAround  = true;
    flkty.options.pageDots    = false;
    flkty.options.autoPlay    = 3000;
    flkty.options.pauseAutoPlayOnHover = false;
    flkty.options.prevNextButtons      = false;
    flkty.resize();
  });
});
